import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sets `data-prerender-ready` on <body> after first paint so vite-plugin-prerender
 * knows the SPA has hydrated. Skips routes that own their own data-driven marker
 * (e.g. /best-cafes/*), so those pages can wait for their content to load before
 * signalling ready.
 */
const SELF_MANAGED_PREFIXES = ["/best-cafes/", "/cafe/", "/work-cafes/"];
// Exact paths that own their own readiness flag (the public homepage).
const SELF_MANAGED_EXACT = ["/"];

export default function PrerenderReady() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (SELF_MANAGED_EXACT.includes(pathname)) return;
    if (SELF_MANAGED_PREFIXES.some((p) => pathname.startsWith(p))) return;
    const id = window.requestAnimationFrame(() => {
      document.body.setAttribute("data-prerender-ready", "true");
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname]);

  return null;
}
